import type { MondayHarmonyField } from "@/lib/types/itsm-config";

/** What makes two references the same Harmony field. */
export function fieldIdentity(field: MondayHarmonyField): string {
  const item = field.kind === "catalog" ? (field.catalog_item_id ?? "") : "";
  return `${field.kind}\u0000${item}\u0000${field.key}`;
}

/** A field option's value: kind, catalog item and key, recoverable. */
export function encodeField(field: MondayHarmonyField): string {
  return JSON.stringify([field.kind, field.catalog_item_id ?? null, field.key]);
}

export function decodeField(value: string): MondayHarmonyField {
  const [kind, catalogItemId, key] = JSON.parse(value) as [
    MondayHarmonyField["kind"],
    string | null,
    string,
  ];
  return { kind, key, catalog_item_id: catalogItemId };
}
